// /authentication/userprofile is a shared, cross-product endpoint — its `roles[]`
// array carries role entries for every Canary app the user has access to, not
// just Everify. These are Everify's own role IDs within that shared array.
export const EVERIFY_ROLE = {
  SUPER_ADMIN: 5,
  COMPANY_ADMIN: 6,
  USER: 7,
};

const dedupeByCompanyId = (roles) => {
  const seen = new Map();
  roles.forEach((role) => {
    const companyId = Number(role?.companyId);
    if (!Number.isFinite(companyId) || companyId <= 0) return;
    if (!seen.has(companyId)) {
      seen.set(companyId, { companyId, name: role?.name || `Company ${companyId}` });
    }
  });
  return Array.from(seen.values());
};

// Determines the user's Everify access tier and the companies they're scoped
// to, from the shared /authentication/userprofile response.
export const deriveEverifyAccess = (profile) => {
  const roles = Array.isArray(profile?.roles) ? profile.roles : [];
  const everifyRoles = roles.filter((role) =>
    [EVERIFY_ROLE.SUPER_ADMIN, EVERIFY_ROLE.COMPANY_ADMIN, EVERIFY_ROLE.USER].includes(
      role?.role
    )
  );

  if (everifyRoles.some((role) => role.role === EVERIFY_ROLE.SUPER_ADMIN)) {
    return { tier: "superadmin", companies: [] };
  }

  const companyAdminRoles = everifyRoles.filter(
    (role) => role.role === EVERIFY_ROLE.COMPANY_ADMIN
  );
  if (companyAdminRoles.length > 0) {
    return { tier: "companyadmin", companies: dedupeByCompanyId(companyAdminRoles) };
  }

  const userRoles = everifyRoles.filter((role) => role.role === EVERIFY_ROLE.USER);
  if (userRoles.length > 0) {
    return { tier: "user", companies: dedupeByCompanyId(userRoles) };
  }

  return { tier: "none", companies: [] };
};
